export default __webpack_public_path__ + "static/media/check.a3408f4d.png";